"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M11 7H5c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1z"];
//# sourceMappingURL=small-minus.js.map